/* eslint-disable react/prop-types */
import React from 'react';
import {
  quotaUsagePercent,
  quotaResetHint,
  normalizeQuota,
  MONTHLY_QUOTA_RESET_HINT,
} from '../../services/aiInsightsApi';

/**
 * Token Usage meter — Lessons Learned Ask Evans sister.
 * Distinguishes: loading, failed to load, and real 0% from API.
 */
const SpacerLogAiQuotaBar = ({ quota, loading = false }) => {
  const parsed = normalizeQuota(quota);
  const pct = quotaUsagePercent(quota);
  const loaded = parsed != null;
  const shown = pct != null ? pct : 0;

  if (loading && !loaded) {
    return (
      <div className="spacer-ask-evans__quota spacer-ask-evans__quota--pending">
        <div className="spacer-ask-evans__quota-text">
          <span className="spacer-ask-evans__quota-label">Token Usage: loading…</span>
          <span className="spacer-ask-evans__quota-hint">{MONTHLY_QUOTA_RESET_HINT}</span>
        </div>
      </div>
    );
  }

  if (!loading && !loaded) {
    return (
      <div className="spacer-ask-evans__quota spacer-ask-evans__quota--pending">
        <div className="spacer-ask-evans__quota-text">
          <span className="spacer-ask-evans__quota-label">
            Token Usage: <strong>—</strong> (could not load)
          </span>
          <span className="spacer-ask-evans__quota-hint">
            Check Network → ai/insights/quota. {MONTHLY_QUOTA_RESET_HINT}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="spacer-ask-evans__quota">
      <div className="spacer-ask-evans__quota-text">
        <span className="spacer-ask-evans__quota-label">
          Token Usage: <strong>{shown}%</strong> used this month
        </span>
        <span className="spacer-ask-evans__quota-hint">{quotaResetHint(quota)}</span>
      </div>
      <div
        className="spacer-ask-evans__quota-track"
        role="progressbar"
        aria-valuenow={shown}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Token usage ${shown}% this month`}
      >
        <div className="spacer-ask-evans__quota-fill" style={{ width: `${shown}%` }} />
      </div>
    </div>
  );
};

export default SpacerLogAiQuotaBar;
